<div class="w-100">
  <div class="row">
    <div *ngIf="leftEmptyCol" class="col-{{ leftEmptyCol }}"></div>
    <bdg-input-field
      class="col-xs-12 col-md-3"
      label="CEP"
      mask="00000-000"
      [control]="form.controls.cep"
      (change)="onCepChange()"
      data-testid="input-cep"
    ></bdg-input-field>
    <bdg-checkbox-field
      class="col-xs-12 col-md-2 mb-3 mb-md-0"
      label="Sem CEP"
      [control]="form.controls.semCEP"
      data-testid="checkbox-sem-cep"
    ></bdg-checkbox-field>
  </div>
  <div class="row">
    <div *ngIf="leftEmptyCol" class="col-{{ leftEmptyCol }}"></div>
    <bdg-input-field
      class="col-xs-12 col-md-3"
      label="Logradouro"
      maxLength="250"
      [control]="form.controls.logradouro"
      data-testid="input-logradouro"
    ></bdg-input-field>
    <bdg-input-field
      class="col-xs-12 col-md-2"
      label="Número"
      maxLength="7"
      [control]="form.controls.numero"
      data-testid="input-numero"
    ></bdg-input-field>
    <bdg-checkbox-field
      class="col-xs-12 col-md-2 mb-3 mb-md-0"
      label="Sem número"
      [control]="form.controls.semNumero"
      data-testid="checkbox-sn"
    ></bdg-checkbox-field>
  </div>
  <div class="row">
    <div *ngIf="leftEmptyCol" class="col-{{ leftEmptyCol }}"></div>
    <bdg-input-field
      class="col-col-xs-12 col-md-2"
      label="Complemento"
      maxLength="50"
      [control]="form.controls.complemento"
      data-testid="input-complemento"
    ></bdg-input-field>
    <bdg-input-field
      class="col-xs-12 col-md-4"
      label="Bairro"
      maxLength="72"
      [control]="form.controls.bairro"
      data-testid="input-bairro"
    ></bdg-input-field>
  </div>
  <div class="row">
    <div *ngIf="leftEmptyCol" class="col-{{ leftEmptyCol }}"></div>
    <app-uf [ufForm]="form.controls.uf" class="col-xs-12 col-md-2"></app-uf>
    <app-municipio
      class="col-xs-12 col-md-4"
      [municipioForm]="form.controls.municipio"
      [municipioProvider]="municipiosProvider"
      (municipioInvalidEvent)="onMunicipioInvalid()"
    ></app-municipio>
  </div>
</div>
